import { CtaButton } from '@tkww/orion-web-ds-action';
import React, { useState } from 'react';
import type { SeasonType } from '../..';
import { useTrackEstimateCTA } from '../../hooks/useTrackEstimateCTA';
import { EstimateFormModal } from '../EstimateFormModal';
import Styles from './styles.scss';

interface EstimateCTAProps {
	selectedSeason: SeasonType;
}

export const EstimateCTA = ({ selectedSeason }: EstimateCTAProps) => {
	const [isModalOpen, setIsModalOpen] = useState(false);

	const trackEstimateCTA = useTrackEstimateCTA();

	const handleClick = () => {
		trackEstimateCTA(selectedSeason);
		setIsModalOpen(true);
	};

	return (
		<>
			<CtaButton
				styleType="secondary"
				size="lg"
				onClick={handleClick}
				className={Styles.estimateCta}
				data-testid="estimate-cta-button"
			>
				Try our price estimator
			</CtaButton>
			<EstimateFormModal
				isModalOpen={isModalOpen}
				closeCallback={() => setIsModalOpen(false)}
			/>
		</>
	);
};
